var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialMediaPreviewGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.411 17.5046H9.85547V18.9231H16.411V17.5046Z",
    fill: "#519BFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 2.07495H9.85547V3.49339H19.9997V2.07495Z",
    fill: "#519BFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05437 1.53744V7.77621C8.05437 8.27739 7.64775 8.68401 7.14657 8.68401H0.907801C0.406619 8.68401 0 8.27739 0 7.77621V1.53744C0 1.03626 0.406619 0.629639 0.907801 0.629639H7.14657C7.64539 0.629639 8.05437 1.03626 8.05437 1.53744Z",
    fill: "#519BFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.411 5.81836H9.85547V7.2368H16.411V5.81836Z",
    fill: "#519BFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05437 13.2237V19.4625C8.05437 19.9637 7.64775 20.3703 7.14657 20.3703H0.907801C0.406619 20.3703 0 19.9637 0 19.4625V13.2237C0 12.7225 0.406619 12.3159 0.907801 12.3159H7.14657C7.64539 12.3159 8.05437 12.7249 8.05437 13.2237Z",
    fill: "#519BFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 13.7612H9.85547V15.1797H19.9997V13.7612Z",
    fill: "#519BFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaPreviewGroupIcon);
export default __webpack_public_path__ + "static/media/socialMediaPreviewGroupIcon.90a377f99b6ab29cb480c342b4b86635.svg";
export { ForwardRef as ReactComponent };